import { Z_TEXT } from '@common/schemas';

export const NIC_REGEX = /^\d{5}$/;

export const Z_NIC = Z_TEXT()
  .regex(NIC_REGEX, { error: 'Le NIC doit être composé de 5 chiffres.' });